import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { toast } from "react-toastify";

import { Modal } from "antd";
import TinyMce from 'components/GbCpn/TinyMce';

const EditDailyReading: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [locale, setLocale] = useState<string>('en')
  const [form, setForm] = useState({
    title: {
      en: '',
      vi: '',
    },
    type: '',
    number: 0,
    description: {
      en: '',
      vi: '',
    },
    key: '',
    is_active: false,
  });

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    // Load dữ liệu theo id
    const fetchData = async () => {
      try {
        setLoadingData(true);
        const response = await fetch(`${API_URL}api/v1/be/numerology_indices/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const json = await response.json();

        let titleParse, descriptionParse;
        try {
          const titleParsed = JSON.parse(json.data.title);
          if (titleParsed && typeof titleParsed === "object" && ("en" in titleParsed || "vi" in titleParsed)) {
            titleParse = titleParsed;
          } else {
            titleParse = { en: json.data.title, vi: '' };
          }
        } catch {
          titleParse = { en: json.data.title, vi: '' };
        }

        try {
          const desParsed = JSON.parse(json.data.description);
          if (desParsed && typeof desParsed === "object" && ("en" in desParsed || "vi" in desParsed)) {
            descriptionParse = desParsed;
          } else {
            descriptionParse = { en: json.data.description, vi: ''};
          }
        } catch {
          descriptionParse = { en: json.data.description, vi: '' };
        }

        if (json.status) {
          setForm({
            ...json.data,
            title: titleParse,
            description: descriptionParse,
          });
        } else {
          toast.error("Lấy dữ liệu thất bại!", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
          navigate('/numerology');
        }
      } catch (error: any) {
        toast.error("Lỗi khi tải dữ liệu: " + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        navigate('/numerology');
      } finally {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const handleSave = async () => {
    if (locale === 'en') {
      if (!form.title.en.trim()) {
        Modal.warning({
          title: "Thiếu dữ liệu",
          content: "Vui lòng nhập tiêu đề",
        });
        return;
      }
      if (!form.key.trim()) {
        Modal.warning({
          title: "Thiếu dữ liệu",
          content: "Vui lòng nhập type",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')
        if (localeData) {
          const token = JSON.parse(localeData).access_token
          const response = await fetch(`${API_URL}api/v1/be/numerology_indices/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success('🦄 Lấy dữ liệu thành công!', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            navigate('/numerology');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
      } catch (error: any) {
        toast.error('Lỗi khi cập nhật: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    } else if (locale === 'vi') {
      if (!form.title.vi.trim()) {
        Modal.warning({
          title: "Thiếu dữ liệu",
          content: "Vui lòng nhập tiêu đề",
        });
        return;
      }
      if (!form.key.trim()) {
        Modal.warning({
          title: "Thiếu dữ liệu",
          content: "Vui lòng nhập type",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')
        if (localeData) {
          const token = JSON.parse(localeData).access_token
          const response = await fetch(`${API_URL}api/v1/be/numerology_indices/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success('🦄 Lấy dữ liệu thành công!', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            navigate('/numerology');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
      } catch (error: any) {
        toast.error('Lỗi khi cập nhật: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  if (loadingData) return <p>Đang tải dữ liệu...</p>;

  return (
    <>
      <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4">Chỉnh sửa Numerology</h4>}>
        <div className="p-4 bg-white rounded shadow">
          <h3 className="text-xl font-bold mb-4" style={{ color: '#5e5873' }}>
            Chỉnh sửa
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Ngôn ngữ
              </label>
              <select
                value={locale}
                onChange={(e) => setLocale(e.target.value)}
                className="w-full border p-2 rounded"
                style={{ border: '1px solid #ccc' }}
              >
                <option value="vi">Vietnam</option>
                <option value="en">English</option>
              </select>
            </div>

            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Title
              </label>
              <input
                type="text"
                value={locale === 'en' ? (form.title.en ?? '') : (form.title.vi ?? '')}
                onChange={(e) =>
                  setForm({
                    ...form,
                    title: {
                      ...form.title,
                      [locale]: e.target.value,
                    },
                  })
                }
                className="w-full border p-2 rounded"
                style={{ border: '1px solid #ccc' }}
              />
            </div>

            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Type
              </label>
              <input
                type="text"
                style={{ border: '1px solid #ccc' }}
                value={form.key}
                onChange={(e) => setForm({ ...form, key: e.target.value })}
                className="w-full border p-2 rounded"
              />
            </div>

            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Number
              </label>
              <input
                type="number"
                min="1"
                max="9"
                value={form.number}
                onChange={(e) => setForm({ ...form, number: Number(e.target.value) })}
                className="w-full border p-2 rounded"
                style={{ border: '1px solid #ccc' }}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
              Nội dung
            </label>
            <div className="border rounded" style={{ border: '1px solid #ccc' }}>
              {/* <Editor
                apiKey="8idrshqq41s3566uw9r35h7yd71a2lhzpzfkn6pywrmjf26k"
                value={form.description}
                init={{
                  height: 300,
                  menubar: 'file edit view insert format tools table help',
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist outdent indent | removeformat | help',
                }}
                onEditorChange={(content: any) => setForm({ ...form, description: content })}
              /> */}
              <TinyMce
                defaultValue={locale === 'en' ? form.description.en : form.description.vi}
                onChange={(value) =>
                  setForm({
                    ...form,
                    description: {
                      ...form.description,
                      [locale]: value,
                    },
                  })
                }
              />
            </div>
          </div>

          <div className="mb-4 flex items-center gap-2" style={{ color: '#5e5873' }}>
            <input
              style={{ width: '20px', height: '20px', border: '1px solid #ccc' }}
              type="checkbox"
              id="is_active"
              checked={form.is_active}
              onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
            />
            <label htmlFor="is_active" className="font-semibold">
              Trạng thái
            </label>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => navigate('/numerology')}
              className="border px-4 py-2 rounded"
              disabled={loading}
            >
              Hủy
            </button>
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Đang xử lý...' : 'Lưu'}
            </button>
          </div>
        </div>
      </SidebarLayout>
    </>
  );
};

export default EditDailyReading;
